// 捷克语
export const GUIDES = [
  { name: 'guide-overview', title: 'Přehled funkcí', groupIndex: 0 },
  { name: 'guide-account', title: 'O účtu', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'O vozidle', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Jak nastavit palubní desku', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Jak nastavit vozidlo', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Jak navigovat k vyhledání vozidla', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Jak používat navigaci', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'O historii jízdy', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Jak provést vlastní kontrolu vozidla', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'Jak provést obecná nastavení APP', groupIndex: 3 },
  { name: 'guide-notice', title: 'Jak zobrazit a nastavit upozornění na zprávy', groupIndex: 3 },
  { name: 'guide-about', title: 'O aplikaci APP', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'čekající',
  1: 'Žádná odpověď',
  2: 'Odpověď',
  3: 'v komunikaci',
  4: 'protiopatření',
  5: 'vyřešeno',
};

export const FEEDBACK_TYPES = {
  1: 'Zpětná vazba',
  2: 'Odpověď',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
